import React, { useMemo } from 'react';

import { Product } from '../../types/Gym';

import { SectionSubTitle } from '../../components/SectionSubTitle/SectionSubTitle';

import styles from '../../components/GymIntro/GymIntro.module.scss';

export type GymIntroProps = {
  name: string;
  products: Product[];
};

export const GymIntro: React.FC<GymIntroProps> = ({ name, products }) => {
  const directProduct = useMemo(() => products && products.find((product) => product.type === 'direct'), [products]);

  return (
    <div className={styles.intro}>
      <SectionSubTitle>Hussle is a marketplace of gyms and spas</SectionSubTitle>
      <p className={styles.intro__description}>
        We connect you with all the best gyms like {name} in your area and offer you a way to visit either through Day
        Passes{directProduct ? ', MultiGym passes or Gym Memberships' : ' or MultiGym passes'}.
      </p>
    </div>
  );
};
